import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <FeaturesSection />
        <AppSection />
        <CardsSection />
        <CarouselSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <FAQSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}